import React, { Component } from 'react'
import TitleBar from '../TitleBar'
import { unauthApi } from '../../utilities/api.js'
import getLabel from   '../../utilities/label.js'
import deviceDetailTemplate from './deviceDetailTemplate'

export default class ContactSupportForm extends Component {
  constructor(props) {
    super(props)
    const email = props.email ? props.email : ''
    const title = props.homepageBlock ?
      props.homepageBlock.title :
      getLabel('contact_support')
    this.state = {
      body: deviceDetailTemplate,
      email: email,
      homepageBlock: props.homepageBlock,
      title: title,
      bodyHasChanged: false
    }
    if (this.props.setActiveTab) {
      this.props.setActiveTab('homepage')
    }
    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handleBodyChange = this.handleBodyChange.bind(this)
    this.submit = this.submit.bind(this)
    window.trackPage('ContactFormScreen')
  }

  componentDidMount() {
    // scroll to top
    window.scrollTo(0,0)
  }

  handleEmailChange(e) {
    const email = e.target.value
    this.setState({
      email: email
    })
  }

  handleBodyChange(e) {
    const body = e.target.value
    this.setState({
      body: body,
      bodyHasChanged: true
    })
  }

  submit(e) {
    e.preventDefault()
    const {
      email,
      body,
      bodyHasChanged,
      homepageBlock
    } = this.state


    if (!this.props.emailRegEx.test(email)) {
      this.props.flashMessage({
        message: getLabel('bad_email'),
        type: 'error'
      })
      return false
    }

    if (!bodyHasChanged) {
      this.props.flashMessage({
        message: getLabel('comment_cannot_be_blank'),
        type: 'error'
      })
      return false
    }

    let data = {
      app_support: {
        email: email,
        body: body,
      }
    }

    if (homepageBlock) {
      data.app_support.homepage_block_id = homepageBlock.id
    }

    const api = window.api ? window.api : unauthApi
    api.post('/app/supports', data).then(() => {
      this.props.flashMessage({
        message: getLabel('support_message'),
        type: 'success'
      })
      this.props.cancel()
    }).catch(() => {
      this.props.flashMessage({
        message: getLabel('http_error_unknown'),
        type: 'error'
      })
    })
  }

  render() {
    return (
      <div>
        <TitleBar title={ this.state.title } />
        <form>
          { this.props.showEmail &&
            <div className='form-group'>
            	<input
            		className='form-control'
            		type='email'
            		placeholder={ getLabel('username') }
            		onChange={ this.handleEmailChange }
            		value={ this.state.email } />
            </div>
          }
          <div className='form-group'>
            <textarea
              style={{ height: '500px' }}
              className='form-control'
              value={ this.state.body }
              onChange={ this.handleBodyChange } />
          </div>
          <div className="center">
            <button
              onClick={ this.submit }
              className='submit-button margin-top-10'>
              { getLabel('submit') }
            </button>
            <button
              className='cancel-button'
              onClick={ this.props.cancel } >
              { getLabel('cancel')}
            </button>
          </div>
        </form>
      </div>
    )
  }
}
